
import type {User} from './types';
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';
// import DropdownMenu from '@/components/DropdownMenu/DropdownMenu.vue';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';

export default defineComponent({
  name: 'OxdUserDropdown',

  components: {
    'oxd-icon': Icon,
    'oxd-dropdown-menu': DropdownMenu,
  },

  props: {
    user: {
      type: Object as PropType<User>,
      required: true,
    },
  },
});
